import React from 'react';
import { Typography, withStyles } from '@material-ui/core';

const styles = {
  wrapper: {
    '& p:nth-child(2)': {
      marginTop: '8px',
    },
  },
  label: {
    fontWeight: '500',
    fontSize: '14px',
    color: '#252726',
  },
  subLabel: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    width: '100%',
    maxWidth: '520px',
    color: 'rgba(37,39,38,0.5)',
    marginBottom: 0,
  },
  fullWidth: {
    maxWidth: '100%',
  },
};
const FormSectionDescription = ({ classes, title, description, additionalDescription, fullWidth = false }) => (
  <div className={classes.wrapper}>
    <Typography variant="body1" className={classes.label}>{title}</Typography>
    {description ?
      <Typography variant="body1" className={`${classes.subLabel} ${fullWidth ? classes.fullWidth : ''}`}>{description}</Typography> : null}
    {additionalDescription ?
      <Typography variant="body1" className={`${classes.subLabel} ${fullWidth ? classes.fullWidth : ''}`}>{additionalDescription}</Typography> : null}
  </div>
);

export default withStyles(styles)(FormSectionDescription);
